import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, ConfigProvider, Flex, Layout, Typography } from 'antd';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { kebabToTitleCase } from '../../utilities/commonFunctions';
import { LeftOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Text } = Typography;

const THEME_CONFIG = {
  components: {
    Typography: {
      titleMarginBottom: 0,
      titleMarginTop: 0,
      fontSize: '1rem',
    },
    Layout: {
      siderBg: 'var(--secondary-fill-color, #2E3033)',
      headerBg: 'transparent',
      headerPadding: '0',
    },
  },
  token: {
    fontSize: '0.875rem',
  },
};

const AdminPageLayout = ({ rootPath, className }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);
  const isMobileView = location.pathname.split('/')[1] === 'mobile';

  const isRootPath = location?.pathname === rootPath;

  useEffect(() => {
    const pathSegments = location?.pathname?.slice(1)?.split('/') || [];
    const items = pathSegments.map((segment, index) => ({
      title: (
        <Link to={pathSegments.slice(1, index + 1).join('/')} key={segment}>
          <Text strong={index === pathSegments.length - 1}>
            {kebabToTitleCase(segment)}
          </Text>
        </Link>
      ),
    }));
    setBreadcrumbItems(items);
  }, [location]);

  const renderHeader = () => {
    return (
      !isRootPath && (
        <Flex gap={10} align="center">
          <LeftOutlined onClick={() => navigate(-1)} />
          <Breadcrumb items={breadcrumbItems} separator=">" />
        </Flex>
      )
    );
  };

  return (
    <ConfigProvider theme={THEME_CONFIG}>
      <Layout className={`layout-page ${className || ''}`}>
        {!isMobileView && <>{renderHeader()}</>}
        <Content className="full-height">
          <Outlet />
        </Content>
      </Layout>
    </ConfigProvider>
  );
};

AdminPageLayout.propTypes = {
  rootPath: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default React.memo(AdminPageLayout);
